import type { CurrentFile } from '@/types'

import Model from './Model'

export default class FileModel extends Model {
  static model: CurrentFile = {
    id: null,
    path: null,
    file: null,
    alt: null,
    sort: 9999,
  }

  static get() {
    return super.get() as CurrentFile
  }

  static prepare(model: CurrentFile, without: (keyof CurrentFile)[]) {
    return super.prepare(model, without) as CurrentFile
  }

  static mergeTogether(model: Partial<CurrentFile>) {
    return super.mergeTogether(model) as CurrentFile
  }

  static difference(
    snapshot: Partial<CurrentFile>,
    formModel: Partial<CurrentFile>
  ) {
    return super.difference(snapshot, formModel)
  }

  static mergeTogetherAndCutExcess<T = Partial<CurrentFile>>(model: T) {
    return super.mergeTogetherAndCutExcess(model) as CurrentFile
  }

  static onlyModelKeysDiff<T = Partial<CurrentFile>>(
    snapshot: T,
    formModel: T
  ) {
    return super.onlyModelKeysDiff(snapshot, formModel) as Partial<CurrentFile>
  }
}
